import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, switchMap, tap } from 'rxjs';
import { environment } from '@env';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class GoogleAuthInterceptor implements HttpInterceptor {

  constructor(private oidcSecurityService: OidcSecurityService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(environment.inCloud.baseUrl + "api/googleDrive")) {
      return next.handle(request);
    }

    return this.oidcSecurityService.getAccessToken().pipe(
      switchMap(token => {
        request = request.clone({
          withCredentials: true,
          headers: request.headers.set('Authorization', `Bearer ${token}`)
        });
        
        return next.handle(request);
      })
    );
  }
}
